// test1374
(1374 && 0);
